import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Button } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import {
  getRolePermissions
} from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import { useParams } from 'react-router';
import TaskManagementView, { TaskManagementViewRef } from './TaskManagementView';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import './TaskManagement.css';
import TaskModal from './common/TaskModal';
import ImportModal from './common/LoadTasks/ImportModal';
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { RootStateType } from 'src/store/RootReducer';
import { GetEmployeeProjectDetails } from 'src/services/projectService';
import TaskTemplates from './common/TaskTemplates';
import { getAllProjects } from 'src/services/projectDetailService';


function TaskManagement() {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const appUser = useSelector((state: RootStateType) => state.appReducer?.user);

  const taskManagementViewRef = useRef<TaskManagementViewRef>(null);


  const isProjectManager = useSelector(
    (state: RootStateType) => state.appReducer.user.IsProjectManager
  );

  const [permissions, setPermissions] = useState([]);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const [taskOpen, setTaskOpen] = useState(false);
  const [openImport, setOpenImport] = useState(false);
  const [templateOpen, setTemplateOpen] = useState(false);

  const [projects, setProjects] = useState<any>([]);
  const [projectId, setProjectId] = useState<string>('');

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Activity Management');
      setPermissions(arr[0].permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  useEffect(() => {
    if (taskManagementViewRef.current) {
      setProjectId(taskManagementViewRef.current.project);
    }
  }, [taskManagementViewRef.current]);

  const toggleTaskOpen = () => {
    setTaskOpen(!taskOpen);
  };

  const toggleTemplateOpen = () => {
    setTemplateOpen(!templateOpen);
  };

  const toggleImport = () => {
    setOpenImport(!openImport);
  };

  const getTableData = () => {
    if (taskManagementViewRef.current) {
      taskManagementViewRef.current.getTasks();
    }
  };

  useEffect(() => {
    const fetchProject = () => {
      if(appUser.Roles.split(',').includes('Super User')){
        getAllProjects().then((res) => {
          const filteredProjects = res.data;
          const newData = [];

          for(let i=0; i < filteredProjects.length; i++){
            newData.push({
              projectId: filteredProjects[i]?.id,
              projectName: filteredProjects[i]?.name,
              isClosed: filteredProjects[i]?.isClosed,
            });
          }
          setProjects(newData.filter(e => !e.isClosed));
        });
      } else {
        GetEmployeeProjectDetails(appUser?.EmployeeId).then((res) => {
          const currentDate = new Date();
          let filteredRanges = res?.data?.filter(range => {
            const start = new Date(range.startDate);
            const end = new Date(range.endDate);
            return currentDate < end && currentDate > start;
          });
  
          let newFilteredRanges = filteredRanges.filter(e => e.role === "Project Manager");
          newFilteredRanges = newFilteredRanges.reduce((acc, item) => {
              if(!acc.includes(e => e.projectCode === item.projectCode)){
                acc.push(item)
              }
              return acc;
            },[]);
  
          setProjects((newFilteredRanges.filter(e => !e.isClosed) as any[]) || []);
        });
      }
    }

    fetchProject();
  }, []);

  //create task
  const onSubmitToCreate = (data: any) => {
    if (taskManagementViewRef.current) {
      taskManagementViewRef.current.onSubmitToCreate(data);
    }
  }

  return (
    <>
      <Helmet>
        <title>Activity Management</title>
      </Helmet>
      <Container maxWidth="xl" className='task-management-container'>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <div>
              <iframe
                title="frame"
                id="my_iframe"
                style={{ display: 'none' }}
              ></iframe>
              <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
                <Grid item display='flex'>
                  <Typography
                    style={{
                      marginLeft: '0px',
                      fontWeight: '700',
                      fontSize: '16px',
                      fontFamily:
                        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                    }}
                  >
                    Timesheet / 
                  </Typography>
                  <Typography variant="subtitle2" className='sub-title'>Activity Management</Typography>
                </Grid>
                <Grid item>
                  <Button
                    sx={{
                      mr: 1,
                      mt: { xs: 2, md: 0 },
                      fontSize: '11px',
                      fontWeight: 'normal'
                    }}
                    variant="contained"
                    id="btn-handleClickOpen"
                    startIcon={<AddTwoToneIcon fontSize="small" />}
                    onClick={() => {
                      setTaskOpen(true);
                    }}
                    style={{ height: '1.75rem' }}
                    /* disabled={
                      !permissions.some(
                        (perm) => perm.name === 'Create Task' && perm.value === true
                      ) || !isProjectManager
                    } */
                  >
                    Create Activity
                  </Button>
                  <Button
                    sx={{
                      mr: 1,
                      mt: { xs: 2, md: 0 },
                      fontSize: '11px',
                      fontWeight: 'normal'
                    }}
                    variant="contained"
                    id="btn-handleClickOpen"
                    startIcon={<ChecklistOutlinedIcon fontSize="small" />}
                    onClick={toggleTemplateOpen}
                    style={{ height: '1.75rem' }}
                    /* disabled={
                      !permissions.some(
                        (perm) => perm.name === 'Load from Template' && perm.value === true
                      ) || !isProjectManager
                    } */
                  >
                    Load from Template
                  </Button>
                  <Button
                    sx={{
                      mt: { xs: 2, md: 0 },
                      fontSize: '11px',
                      fontWeight: 'normal'
                    }}
                    variant="contained"
                    id="btn-handleClickOpen"
                    startIcon={<FileUploadOutlinedIcon fontSize="small" />}
                    onClick={toggleImport}
                    style={{ height: '1.75rem' }}
                    /* disabled={
                      !permissions.some(
                        (perm) => perm.name === 'Load from XLS' && perm.value === true
                      ) || !isProjectManager
                    } */
                  >
                    Load from XLS
                  </Button>
                </Grid>
              </Grid>
            </div>
            <TaskManagementView 
              toggleOpen={toggleTaskOpen}
              ref={taskManagementViewRef}
              projectsList={projects}
              tab={params.type}
              permissions={permissions}/>
          </Grid>
        </Grid>
        <TaskModal
          open={taskOpen}
          toggle={toggleTaskOpen}
          type='CREATE'
          onSave={onSubmitToCreate}
        />
        <TaskTemplates
          open={templateOpen}
          toggle={toggleTemplateOpen}
          getData={getTableData}
          projectsList={projects}
          projectId={projectId}
        />
        <ImportModal
          open={openImport}
          toggle={toggleImport}
          getData={getTableData}
          projectId={projectId}
        />
        <SnackBar />
      </Container>
    </>
  );
}

export default TaskManagement;
